import { render } from "./App.vue?vue&type=template&id=58b6c678&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=58b6c678&lang=scss"

import exportComponent from "C:\\wamp64\\www\\skinner\\new_wp\\quiz-plugin\\wp-vue-quiz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__